// Resuelve el filename de un archivo (boceto, etc.) a una URL ABSOLUTA cargable.
// Los bocetos subidos por el BACKOFFICE quedan como ruta relativa "/uploads/..." (la sirve V4),
// mientras que los del diseñador/Spaces ya vienen como URL completa. El <img> del front necesita
// una URL absoluta: si es relativa, se le antepone el base de V4 (que sirve /uploads).
// OJO: NO usar REACT_APP_V3_API_URL — apunta a v3core.blue (server viejo de V3), que NO tiene
// estos archivos. Los /uploads los sirve V4 (v4.micuenta.blue). Override opcional por env propia.
const V4_BASE = (process.env.REACT_APP_V4_FILES_URL || "https://v4.micuenta.blue").replace(/\/+$/, "");

export const resolveFileUrl = (filename) => {
  const f = String(filename || "").trim();
  if (!f) return "";
  if (/^https?:\/\//i.test(f)) return f; // ya es absoluta (Spaces u otra)
  return `${V4_BASE}/${f.replace(/^\/+/, "")}`;
};
